import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiTrendingUp, FiEye, FiShield } from 'react-icons/fi';

const Bonus = () => {
  const benefits = [
    { icon: FiTrendingUp, text: "Build stronger authority online" },
    { icon: FiEye, text: "See what customers notice first" },
    { icon: FiShield, text: "Strengthen your reputation foundation" }
  ];

  return (
    <section className="py-16 px-6 max-w-4xl mx-auto">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="bg-gradient-to-br from-dc-teal-deep to-dc-teal-deep/95 text-white rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-float"
      >
        {/* Subtle background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-dc-teal-signal rounded-full blur-[120px] opacity-15 pointer-events-none"></div>
        <div className="absolute top-0 right-0 w-64 h-64 bg-dc-gold-1 rounded-full blur-[100px] opacity-10 pointer-events-none"></div>
        
        <div className="relative z-10">
          <h2 className="text-xl md:text-2xl font-semibold mb-8 text-dc-bg font-display uppercase tracking-wider text-xs">
            Included With Both Memberships
          </h2>
          
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 md:p-10 max-w-2xl mx-auto mb-8">
            <div className="flex justify-center mb-6">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/72d2508c2498c1755558cb43ced92309.png" 
                alt="Reputation Upgrade" 
                className="h-20 md:h-24 object-contain drop-shadow-lg" 
              />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-3">RepUpgrade Reputation Report</h3>
            <div className="flex items-center justify-center gap-3 mb-6 font-display text-xs uppercase tracking-wider text-dc-gold-2 font-semibold">
              <span>$199 Value</span>
              <span className="w-1 h-1 rounded-full bg-dc-gold-1"></span>
              <span>Included With Both Memberships</span>
            </div>
            
            <p className="text-white/90 leading-relaxed text-sm md:text-base mb-6">
              Every membership includes a free RepUpgrade Reputation Report, valued at $199. It gives members a clearer look at how their business shows up, what their reputation already says, and where trust can be strengthened next.
            </p>

            <div className="grid grid-cols-3 gap-4 mt-8 pt-6 border-t border-white/10">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="text-center">
                  <SafeIcon icon={benefit.icon} className="w-5 h-5 mx-auto mb-2 text-dc-gold-1" />
                  <p className="text-xs text-white/70 leading-tight">{benefit.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Bonus;